export const CLIENT_STATUS = {
  CREATED: 'CREATED',
  IDENTIFIED: 'IDENTIFIED',
  REVIEWED: 'REVIEWED',
  FIXED: 'FIXED',
};

export const NINE_MINUTES_IN_MS = 9 * 60 * 1000;
